import { TableV2 } from '@anytag/shared-atoms';
import { TableData } from '@anytag/shared-types';
import { InstagramCompareFeedPost } from '@anytag/graphql';
import { InstagramComparePostDetailsModal } from '@anytag/shared-molecules';
import { useAnalyticsInstagramComparePostsListTable } from './hooks';

export type AnalyticsInstagramComparePostsListProps = TableData<InstagramCompareFeedPost>;

export const AnalyticsInstagramComparePostsList = ({ loading, data = [] }: AnalyticsInstagramComparePostsListProps) => {
  const { columns } = useAnalyticsInstagramComparePostsListTable();

  return (
    <>
      <TableV2 loading={loading} data={data} columns={columns} rowHeight="62px" noTopBorderRadius hasBorder />

      <InstagramComparePostDetailsModal posts={data} />
    </>
  );
};
